import { preloadIntentBasedOnboardingState } from '@confluence/onboarding-helpers/entry-points/preloadIntentBasedOnboardingState';
import { preloadGetLicensedProductsQuery } from '@confluence/onboarding-helpers/entry-points/preloadGetLicensedProductsQuery';

export const INTENT_BASED_ONBOARDING_QUERY = 'IntentBasedOnboardingQuery';

export const preloadIntentBasedOnboarding = () => {
	return Promise.all([preloadIntentBasedOnboardingState(), preloadGetLicensedProductsQuery()]);
};
